module.exports = __webpack_public_path__ + "static/media/covid19Clean.d204a3de.png";